<template>
    <div class="home">
        <indexPromoSection></indexPromoSection>
        <formSection class="form-section-terraces" v-if="formSetUp != null && formSetUp.form_about_init == 'true'"></formSection>
        <aboutSection></aboutSection>
        <formSection class="form-section-terraces form-section-location" v-if="formSetUp != null && formSetUp.form_location_init == 'true'"></formSection>
        <locationSection></locationSection>
        <aroundSection></aroundSection>
        <formSection class="form-section-terraces" v-if="formSetUp != null && formSetUp.form_study_init == 'true'"></formSection>
        <studySection></studySection>
        <formSection class="form-section-terraces form-section-genplan" v-if="formSetUp != null && formSetUp.form_genplan_init == 'true'"></formSection>
        <genplanSection></genplanSection>
        <archSection></archSection>
        <formSection class="form-section-terraces" v-if="formSetUp != null && formSetUp.form_terraces_init == 'true'"></formSection>
        <terracesSection></terracesSection>
        <formSection class="form-section-terraces" v-if="formSetUp != null && formSetUp.form_houses_init == 'true'"></formSection>
        <cityHousesSection></cityHousesSection>
        <!-- <taunHouseSection/> -->
        <streetRetailSection></streetRetailSection>
        <formSection class="form-section-terraces" v-if="formSetUp != null && formSetUp.form_gingo_init == 'true'"></formSection>
        <gingoSection></gingoSection>
        <landSection></landSection>
        <formSection class="form-section-terraces" v-if="formSetUp != null && formSetUp.form_fountain_init == 'true'"></formSection>
        <fountainSection></fountainSection>
        <gameSection></gameSection>
        <formSection class="form-section-game" v-if="formSetUp != null && formSetUp.form_about_init == 'true'"></formSection>
        <courtyardsSection></courtyardsSection>
        <lobbiSection></lobbiSection>
        <safeSection></safeSection>
        <!-- <accentsSection></accentsSection> -->
        <formSection class="form-section-top"></formSection>
        <CRMflats v-if="salesCardPage != null && pageSetup != null"></CRMflats>
        <formSection class="form-section-bottom"></formSection>
        <gallerySection></gallerySection>
        <newsSection></newsSection>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import indexPromoSection from '@/components/index-promo/index-promo.vue'
import aboutSection from '@/components/about/about-section.vue'
import locationSection from '@/components/location/location-section.vue'
import aroundSection from '@/components/around/around-section.vue'
import studySection from '@/components/study/study-section.vue'
import genplanSection from '@/components/genplan/genplan-section.vue'
import archSection from '@/components/arch/arch-section.vue'
import terracesSection from '@/components/terraces/terraces-section.vue'
import cityHousesSection from '@/components/city-houses/city-houses-section.vue'
// import taunHouseSection from '@/components/taunhouse/taunhouse-section.vue'

import streetRetailSection from '@/components/street-retail/street-section.vue'
import gingoSection from '@/components/landscaping/gingo-section.vue'
import landSection from '@/components/landscaping/land-section.vue'
import fountainSection from '@/components/landscaping/fountain-section.vue'
import gameSection from '@/components/game/game-section.vue'
import courtyardsSection from '@/components/courtyards/courtyards-section.vue'
import lobbiSection from '@/components/lobbi/lobbi-section.vue'
import safeSection from '@/components/safe/safe-section.vue'
// import accentsSection from '@/components/accents/accents-section.vue'
import CRMflats from '@/components/flats-crm/flats-crm-section.vue'
import gallerySection from '@/components/gallery/gallery-section.vue'
import newsSection from '@/components/news/news.vue'
import formSection from '@/components/forms/form-section.vue'

export default {
    name: 'HomeView',
    components: {
        indexPromoSection,
        aboutSection,
        locationSection,
        aroundSection,
        studySection,
        genplanSection,
        archSection,
        terracesSection,
        cityHousesSection,
        // taunHouseSection,
        streetRetailSection,
        streetRetailSection,
        gingoSection,
        landSection,
        fountainSection,
        gameSection,
        courtyardsSection,
        lobbiSection,
        safeSection,
        // accentsSection,
        CRMflats,
        gallerySection,
        newsSection,
        formSection,
    },
    computed: mapGetters({
        pageSetup: 'loadPageSetUp',
        salesCardPage: 'loadSalesCardPage',
        formSetUp: 'loadFormSetUp',
    }),
    methods: {
    },
}
</script>

<style lang="scss">
    @import '@/styles/components/home.scss';
</style>

